module.exports = __webpack_public_path__ + "img/The-Micro_fr.9f0118ae.jpg";